export const data9_4 = [{
    percent: "0",
    note: "",
    year_c: '0',
    YTD: '0',
    charges: "0",
    balance: "0"
}]


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-6/data.js